module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/mobile-banner-927a7b92237fc7c1a8f7cbdc4b2f5134.webp";